// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
    {
        path: '/',
        component: () => import('@/views/Index.vue')
    },
    {
        path: '/doctor',
        component: () => import('@/views/doctor/Home.vue'),
    },
    {
        path: '/doctor/login',
        component: () => import('@/views/doctor/Login.vue')
    },
    {
        path: '/doctor/change-password',
        component: () => import('@/views/doctor/ChangePassword.vue')
    },
    {
        path: '/doctor/add-point',
        component: () => import('@/views/doctor/AddPoint.vue')
    },
    {
        path: '/doctor/exchange-point',
        component: () => import('@/views/doctor/ExchangePoint.vue')
    },
    {
        path: '/doctor/health-info',
        component: () => import('@/views/doctor/HealthInfo.vue')
    },
    {
        path: '/doctor/health-info-detail/:id',
        component: () => import('@/views/doctor/HealthInfoDetail.vue')
    },
    {
        path: '/doctor/public-notice',
        component: () => import('@/views/doctor/PublicNotice.vue')
    },
    {
        path: '/doctor/user-registration',
        component: () => import('@/views/doctor/UserRegistration.vue')
    },
    {
        path: '/doctor/family-binding',
        component: () => import('@/views/doctor/FamilyBinding.vue')
    },
    {
        path: '/doctor/public-notice/detail/:id',
        component: () => import('@/views/doctor/PublicNoticeDetail.vue')
    },
    {
        path: '/resident',
        component: () => import('@/views/resident/ResidentLayout.vue'),
        children: [
            {
                path: '',
                redirect: '/resident/chronic'
            },
            {
                path: 'chronic',
                component: () => import('@/views/resident/Chronic.vue')
            },
            {
                path: 'family',
                component: () => import('@/views/resident/Family.vue')
            },
            {
                path: 'notice',
                component: () => import('@/views/resident/Notice.vue')
            }
        ]
    },
    // 血压录入
    {
        path: '/resident/bp-record',
        component: () => import('@/views/resident/BloodPressureRecord.vue')
    },
    // 血糖录入
    {
        path: '/resident/bs-record',
        component: () => import('@/views/resident/BloodSugarRecord.vue')
    },
    // 血压打卡历史
    {
        path: '/resident/bp-history',
        component: () => import('@/views/resident/BloodPressureHistory.vue')
    },
    // 血糖打卡历史
    {
        path: '/resident/bs-history',
        component: () => import('@/views/resident/BloodSugarHistory.vue')
    },
    // 扫码绑定
    {
        path: '/resident/scan-bind',
        component: () => import('@/views/resident/ScanBind.vue')
    },
    // 待同意列表
    {
        path: '/resident/consent-list',
        component: () => import('@/views/resident/ConsentList.vue')
    },
    {
        path: '/resident/login',
        component: () => import('@/views/resident/Login.vue')
    },
    {
        path: '/resident/register',
        component: () => import('@/views/resident/UserRegistration.vue')
    },
    {
        path: '/resident/profile',
        component: () => import('@/views/resident/Profile.vue')
    },
    {
        path: '/resident/my-info',
        component: () => import('@/views/resident/MyInfo.vue')
    },
    {
        path: '/resident/point-history',
        component: () => import('@/views/resident/PointHistory.vue')
    },
    {
        path: '/resident/point-rule',
        component: () => import('@/views/resident/PointRule.vue')
    },
    {
        path: '/resident/exchange-catalog',
        component: () => import('@/views/resident/ExchangeCatalog.vue')
    },
    {
        path: '/resident/health-info',
        component: () => import('@/views/resident/HealthInfo.vue')
    },
    {
        path: '/resident/health-info-detail/:id',
        component: () => import('@/views/resident/HealthInfoDetail.vue')
    },
    {
        path: '/resident/public-notice',
        component: () => import('@/views/resident/PublicNotice.vue')
    },
    {
        path: '/resident/public-notice/detail/:id',
        component: () => import('@/views/resident/PublicNoticeDetail.vue')
    },
    {
        path: '/scan-qrcode',
        component: () => import('@/views/ScanQRCode.vue')
    },
    {
        path: '/:pathMatch(.*)*', // 捕获所有未匹配路由
        redirect: '/' // 重定向到指定页面
    }
]

const router = createRouter({
    // 与 vite.config.js 中 base 选项一致
    history: createWebHistory(import.meta.env.VITE_BASE_PATH),
    routes
})

export default router
